import * as dependents from '../xhr/dependents.js';
import * as notifier from './notifier.js';
import * as loader from './loader.js';
import { i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 *
 * @param userID
 * @param body
 * @returns {function(*): Promise<boolean | void>}
 */
export function sendForgotPasswordEmail(userID, body) {
    return (dispatch) => {
        setLoader(dispatch, true);

        return dependents
            .sendForgotPasswordEmail(userID, body)
            .then(() => {
                dispatch(notifier.displayMessage(i18n.t(tokens.labels.notifications.passwordChangedSuccessfully)));
                setLoader(dispatch, false);

                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}